import CurrencyFormatInput from '@/components/currency-format-input/currency-format-input.vue'
import IcEdit from '@/assets/svg/ic-edit.svg?inline'
import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'CurrencyFormatInputEdit',
  components: {
    CurrencyFormatInput,
    IcEdit
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: 'Сумма:'
    }
  },
  data() {
    return {
      isEdit: false,
      valueWidth: 0
    }
  },
  computed: {
    styleInput() {
      return {
        width: `${this.valueWidth}px`,
        display: this.isEdit ? 'inline-block' : 'none'
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setValueWidth()
    })
  },
  methods: {
    numberWithSeparator,

    setValueWidth() {
      this.valueWidth = this.$refs['form-control-value'].getBoundingClientRect().width
    },

    onEdit() {
      this.isEdit = true
      this.$nextTick(() => {
        this.$refs['form-control-input'].$el.focus()
      })
    }
  },
  watch: {
    value() {
      this.$nextTick(() => {
        this.setValueWidth()
      })
    }
  }
}